if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('click', this.onThumbnailClick.bind(this));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      onThumbnailClick(event) {
        const thumb = event.target.closest('.product-media-modal__thumb');
        if (!thumb || !this.contains(thumb)) return;
        event.preventDefault();
        const mediaId = thumb.getAttribute('data-media-id');
        if (!mediaId) return;
        this.showActiveMedia(mediaId);
        }

      setActiveThumbnail(mediaId) {
        this.querySelectorAll('.product-media-modal__thumb').forEach((btn) => {
          const active = btn.getAttribute('data-media-id') === mediaId;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
          btn.setAttribute('tabindex', active ? '0' : '-1');
        });
      }

      showActiveMedia(mediaId) {
        const id =
          mediaId ||
          (this.openedBy && this.openedBy.getAttribute && this.openedBy.getAttribute('data-media-id'));
        if (!id) return;

        const modalContent = this.querySelector('.product-media-modal__content');
        if (!modalContent) return;

        modalContent.querySelectorAll('[data-media-id]').forEach((element) => {
          if (element.getAttribute('data-media-id') !== id) {
            element.classList.remove('active');
          }
        });

        const activeMedia = modalContent.querySelector(`[data-media-id="${id}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.setActiveThumbnail(id);

        if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
          activeMedia.loadContent(false);
        }
      }
    }
  );
}
